"use client";

import { BaseServiceKey } from "@erp/shared-libs/common";
import { useLoading } from "@erp/shared-libs/hooks";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { isUndefined } from "lodash-es";
import { FC, PropsWithChildren, useEffect } from "react";

interface LoadingGuardProps extends PropsWithChildren {
  /**
   * 是否保護 children，不讓 loading 時顯示
   * @default false
   */
  isGuarding?: boolean;
  isLoading?: boolean;
}

export const LoadingGuard: FC<LoadingGuardProps> = ({ children, isLoading, isGuarding }) => {
  const { showLoading, hideLoading } = useLoading();

  const isMutating = useIsMutating({
    predicate(mutation) {
      return !mutation.options.mutationKey?.includes(BaseServiceKey.IgnoreLoadingGuard);
    },
  });

  const isFetching = useIsFetching({
    predicate(query) {
      return !query.queryKey.includes(BaseServiceKey.IgnoreLoadingGuard);
    },
  });

  // ----- Effects
  useEffect(() => {
    const finalLoading = !isUndefined(isLoading) ? isLoading : isFetching + isMutating > 0;

    if (finalLoading) {
      showLoading();
    } else {
      hideLoading();
    }
  }, [showLoading, hideLoading, isFetching, isLoading, isMutating]);

  if (isLoading && isGuarding) {
    return <></>;
  }

  return children;
};
